import type { FaireProductEntity } from "../../entity_types/product";

export const p_2m829kmbt4: FaireProductEntity = {
  token: "p_2m829kmbt4",
  type: "product",
  name: "Zen Buddha Sand Garden",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/de578f6fa2d2fb62099518a258da5705c42a59517d2dc7bd1ac39865b4d3d9fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a59ccf5e8e3906bbc5fc1816210dec16df279e6b28912322eea7dc6eea8c5acc.jpeg",
    "https://cdn.faire.com/fastly/993ba8146edb925f0887930aa17690fcc823094cc7f9e79bc98b9c2a885e9a89.jpeg",
    "https://cdn.faire.com/fastly/06f4b2b8906de6ab74e9486c0d693060900023c4737d5169ce70eac62ddddc66.jpeg",
    "https://cdn.faire.com/fastly/0f11709140910923d2ffe5d170c580c5f98c191c2807e0e7ad07a99cf1b808ed.jpeg",
    "https://cdn.faire.com/fastly/0979a02239973e33f9d09e907433fd50f22ce730434a4af0f1064d35113bc98d.jpeg",
  ],
  priceDollars: 12.47,
  description:
    'Zen Buddha Sand Garden\nProduct Size: 9.4" X 8.6" X 5.1"\nMaterial: Cold Cast Resin\nCase Pack: 18',
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:28.167Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
